// Service sections that other modules' pages embed (#253): Ticket's internal
// workflow steps (register / CSKH verification / finance verification forms)
// and the notification-tracking card on the ticket detail. Registered from
// `./index` at bootstrap; the page renders them by id and does not import
// Service. Prop types: `src/types/slot-props.ts`.
// Contract: `src/lib/slots.tsx`. Registrations only.
import { registerSlot } from '@/lib/slots'

registerSlot({
    id: 'service.workflow-register',
    load: () =>
        import(
            './components/Detail/TabComponents/Information/InternalTicketWorkflow/RegisterService'
        ),
})
registerSlot({
    id: 'service.workflow-cskh-verification',
    load: () =>
        import(
            './components/Detail/TabComponents/Information/InternalTicketWorkflow/CSKHVerificationForm'
        ),
})
registerSlot({
    id: 'service.workflow-finance-verification',
    load: () =>
        import(
            './components/Detail/TabComponents/Information/InternalTicketWorkflow/FinanceVerificationForm'
        ),
})
registerSlot({
    id: 'service.notification-tracking',
    load: () =>
        import(
            './components/Detail/Templates/shared/ServiceNotifications/Tracking'
        ),
})
